export const mapProductsSelector = state => state.whiteLabel.products.get('mapProducts');
export const mapProductsIsLoadingSelector = state => state.whiteLabel.products.get('isLoading');
